export const CATEGORIES_KEYS = Object.freeze({
  purchasedGoodsAndServices: "purchasedGoodsAndServices",
  capitalGoods: "capitalGoods",
  fuelAndEnergyRelatedActivities: "fuelAndEnergyRelatedActivities",
  upstreamTransportationAndDistribution: "upstreamTransportationAndDistribution",
  wasteGeneratedInOperations: "wasteGeneratedInOperations",
  businessTravel: "businessTravel",
  employeeCommuting: "employeeCommuting",
  upstreamLeasedAssets: "upstreamLeasedAssets",
  downstreamTransportationAndDistribution: "downstreamTransportationAndDistribution",
  processingOfSoldProducts: "processingOfSoldProducts",
  useOfSoldProducts: "useOfSoldProducts",
  treatmentOfSoldProducts: "treatmentOfSoldProducts",
  downstreamLeasedAssets: "downstreamLeasedAssets",
  franchises: "franchises",
  investments: "investments"
});

export const CATEGORIES_STEPS = [
  CATEGORIES_KEYS.purchasedGoodsAndServices,
  CATEGORIES_KEYS.capitalGoods,
  CATEGORIES_KEYS.fuelAndEnergyRelatedActivities,
  CATEGORIES_KEYS.upstreamTransportationAndDistribution,
  CATEGORIES_KEYS.wasteGeneratedInOperations,
  CATEGORIES_KEYS.businessTravel,
  CATEGORIES_KEYS.employeeCommuting,
  CATEGORIES_KEYS.upstreamLeasedAssets,
  CATEGORIES_KEYS.downstreamTransportationAndDistribution,
  CATEGORIES_KEYS.processingOfSoldProducts,
  CATEGORIES_KEYS.useOfSoldProducts,
  CATEGORIES_KEYS.treatmentOfSoldProducts,
  CATEGORIES_KEYS.downstreamLeasedAssets,
  CATEGORIES_KEYS.franchises,
  CATEGORIES_KEYS.investments
];
